import constants from "../../common/restService/constant";
import GatewayGet from "../../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getDdSCACData = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_CARRIERS_SCAC";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = [
    {
      value: "all",
      text: "ALL",
    },
    ...(await GatewayGet(props, props.input)),
  ];
  return result;
};

export const updateCarrierMasterParent = async (data) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_MASTER_DB_OPS_ADD_P";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;
  const result = await GatewayGet(props, props.input);
  return result;
};

export const updateCarrierMasterChild = async (data) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_MASTER_DB_OPS_EDIT_C";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;
  const result = await GatewayGet(props, props.input);
  return result;
};

export const addCarrierMasterChild = async (data) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_MASTER_DB_OPS_ADD_C";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;
  const result = await GatewayGet(props, props.input);
  return result;
};